import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import EventListener from 'react-event-listener';
import Waypoint from 'react-waypoint';
import Paper from 'material-ui/Paper';
import transitions from 'material-ui/styles/transitions';
import _ from 'lodash';

export default class Sticky extends PureComponent {
  static stickyStack = [];
  static stickWithSetState = {};

  static contextTypes = {
    subscribe: PropTypes.func,
    unsubscribe: PropTypes.func,
  };

  static stickStackRemove(id) {
    const stickWithSetState = Sticky.stickWithSetState[id];
    if (stickWithSetState) {
      _.forEach(stickWithSetState, setState => {
        setState({shouldStick: false});
      });
    }
    _.remove(Sticky.stickyStack, sticky => sticky.id === id);
  }
  static stickyStackPush(id, height) {
    const offset = this.getOffset();
    Sticky.stickyStack.push({id, height});
    const stickWithSetState = Sticky.stickWithSetState[id];
    if (stickWithSetState) {
      _.forEach(stickWithSetState, setState => {
        setState({shouldStick: true});
      });
    }
    return offset;
  }

  static getOffset() {
    return _.reduce(Sticky.stickyStack, (offset, {height}) => offset + height, 0);
  }

  static stickWith(id, setState) {
    if (!Sticky.stickWithSetState[id]) {
      Sticky.stickWithSetState[id] = [];
    }
    Sticky.stickWithSetState[id].push(setState);
  }

  static stickWithRemove(id, setState) {
    _.remove(Sticky.stickWithSetState[id], setState);
  }

  componentWillMount() {
    const {id, stickWith} = this.props;
    this.id = id || _.uniqueId('sticky');
    this.setState({
      shouldStick: false,
    });
    if (stickWith) {
      this.bindedSetState = this.setState.bind(this);
      Sticky.stickWith(stickWith, this.bindedSetState);
    }
    if (this.context.subscribe) {
      this.context.subscribe(this.handleContainerEvent);
    }
  }

  componentWillUpdate(nextProps, nextState) {
    if (!this.state.shouldStick && nextState.shouldStick) {
      const {stickWith, topOffset, fullWidth} = nextProps;
      const scrollableAncestorBounds = (this.waypointRef && this.waypointRef.scrollableAncestor !== window) ? this.waypointRef.scrollableAncestor.getBoundingClientRect() : {top: topOffset};
      const titleBounds = this.rootRef.getBoundingClientRect();
      const width = fullWidth ? '100%' : this.rootRef.clientWidth;
      const height = this.rootRef.clientHeight;
      const offset = Sticky.stickyStackPush(this.id, height);
      this.rootStyle = {
        ...nextProps.style,
        width,
        height,
      };
      this.wrapperStyle = {
        overflow: fullWidth ? 'visible' : 'hidden',
        width: width,
        top: scrollableAncestorBounds.top + (stickWith ? offset : 0),
        left: titleBounds.left,
        height: height + 10,
        position: 'fixed',
      };
    } else if (this.state.shouldStick && !nextState.shouldStick) {
      Sticky.stickStackRemove(this.id);
    }
  }

  componentWillUnmount() {
    Sticky.stickStackRemove(this.id);
    Sticky.stickWithRemove(this.bindedSetState);
    if (this.context.unsubscribe) {
      this.context.unsubscribe(this.handleContainerEvent);
    }
  }

  handleContainerEvent = ({distanceFromTop, distanceFromBottom}) => {
    const {topOffset, bottomOffset} = this.props;
    const shouldStick = distanceFromTop <= topOffset && distanceFromBottom > bottomOffset;
    this.setState({shouldStick});
  };

  handleWaypointPositionChange = ({currentPosition}) => {
    const {disabled} = this.props;
    this.setState({shouldStick: !disabled && currentPosition === Waypoint.above});
  };

  handleWaypointRef = (ref) => {
    if (ref) {
      this.waypointRef = ref;
    }
  };

  handleRootRef = (ref) => {
    if (ref) {
      this.rootRef = ref;
    }
  };

  handleResize = () => {
    const {shouldStick} = this.state;
    if (shouldStick) {
      this.setState({shouldStick: false});
    }
  };

  isWaypointSupported() {
    return this.context.subscribe === undefined;
  }

  render() {
    const {stickWith, zIndex, style, children, disabled, bottomOffset, topOffset, fullWidth, ...other} = this.props;
    const {shouldStick} = this.state;
    const stick = shouldStick && !disabled;
    const rootStyle = stick ? this.rootStyle : style;
    return (
      <div
        style={stick ? {zIndex, position: 'relative', height: this.rootStyle && this.rootStyle.height} : undefined}
        id = {this.id}
      >
        {this.isWaypointSupported() && <Waypoint ref={this.handleWaypointRef} onPositionChange={stickWith ? undefined : this.handleWaypointPositionChange}/>}
        <div
          style={stick ? this.wrapperStyle : undefined}
          ref={this.handleRootRef}
        >
          <Paper
            zDepth={stick ? 1 : 0}
            style={{...rootStyle, transition: transitions.easeOut('150ms')}}
            {...other}
          >
            {children}
          </Paper>
        </div>
        <EventListener
          target="window"
          onResize={this.handleResize}
        />
      </div>
    );
  }

}

Sticky.propTypes = {
  zIndex: PropTypes.number, // used to control the zindex of the root element so the sticky element can rise above siblings
  stickWith: PropTypes.string, // id of element to stick with
  fullWidth: PropTypes.bool,
};

Sticky.defaultProps = {
  zIndex: 2, // default above MUI hint text etc,
  topOffset: 0,
  bottomOffset: 0,
};